exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-box{\n    margin-top: -16px;\n    margin-right: 10px;\n    /* float: right; */\n    width: 122px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/common/pagination/pagination.component.css
// module id = ../../../../../src/app/components/common/pagination/pagination.component.css
// module chunks = main